import { render, staticRenderFns } from "./study-approval-confirm.vue?vue&type=template&id=d5aab71c&scoped=true&"
import script from "./study-approval-confirm.vue?vue&type=script&lang=js&"
export * from "./study-approval-confirm.vue?vue&type=script&lang=js&"
import style0 from "./study-approval-confirm.vue?vue&type=style&index=0&id=d5aab71c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5aab71c",
  null
  
)

component.options.__file = "study-approval-confirm.vue"
export default component.exports